module.exports = ".changeaddhover:hover {\n    cursor: pointer;\n}"